/**
 * Player-facing copy for a failed guess. A missing daily answer and a
 * swallowed INTERNAL error both stay retryable; the board is not ended.
 */
export function gameGuessErrorMessage(err, game) {
  const raw = `${err?.code || ""} ${err?.message || ""}`;
  if (/no word drop|no number drop|word isn.t ready|number isn.t ready|not-found|not found/i.test(raw)) {
    return game === "number"
      ? "Today's number isn't ready yet, check back soon"
      : "Today's word isn't ready yet, check back soon";
  }
  const cleaned = String(err?.message || "")
    .replace(/^FirebaseError:\s*/i, "")
    .replace(/^functions\/[a-z-]+:\s*/i, "")
    .trim();
  if (!cleaned || /^internal$/i.test(cleaned)) {
    return "That guess didn't go through. Try again.";
  }
  return cleaned;
}
